import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import Home from "./pages/Home";
import Checkout from "./pages/Checkout";
import Login from "./pages/Login";
import Profile from "./pages/Profile";
import Success from "./pages/Success";
import Prefernces from "./pages/Preferences";
import BottomTabBar from "./components/BottomTabBar";
import { SuprSendProvider } from "@suprsend/react";

export const CartContext = React.createContext([]);

export async function getToken(user, tenant) {
  let url = `${process.env.REACT_APP_SS_HOST}/authentication-token/${user}`;

  if (tenant) {
    url += `?tenant_id=${tenant}`;
  }

  const tokenResp = await fetch(url);
  const tokenData = await tokenResp.json();
  return tokenData.token;
}

function PrivateRoute(props) {
  const user = localStorage.getItem("user");
  const userData = JSON.parse(user);

  const [distId, setDistId] = useState();
  const [userToken, setUsertoken] = useState();

  useEffect(() => {
    const distinctId = userData?.email;
    if (distinctId) {
      setSSUser(distinctId);
    }
  }, []);

  const setSSUser = async (distId) => {
    const tenant = userData.tenant;
    const userToken = await getToken(distId, tenant);
    setUsertoken(userToken);
    setDistId(distId);
  };

  console.log("userData", distId);
  if (user) {
    return (
      <SuprSendProvider
        publicApiKey={process.env.REACT_APP_SS_PUBLIC_KEY}
        distinctId={distId}
        vapidKey={process.env.REACT_APP_SS_VAPID}
        userToken={userToken}
        refreshUserToken={() => {
          const tenant = userData.tenant;
          return getToken(distId, tenant);
        }}
        host={process.env.REACT_APP_SS_HOST}
      >
        {props.children}
      </SuprSendProvider>
    );
  } else {
    return <Redirect to="/login" />;
  }
}

function ProtectedRoute(props) {
  if (localStorage.getItem("user")) {
    return <Redirect to="/" />;
  } else {
    return props.children;
  }
}

function App() {
  const [cartList, setCartList] = useState([]);
  const isPreference = window.location.pathname.includes("preferences");

  return (
    <div className="App">
      <CartContext.Provider value={{ cartList, setCartList }}>
        <Router>
          {!isPreference && <BottomTabBar />}
          <Switch>
            <ProtectedRoute exact path="/login">
              <Login />
            </ProtectedRoute>
            <PrivateRoute exact path="/">
              <Home />
            </PrivateRoute>
            <PrivateRoute exact path="/preferences">
              <Prefernces />
            </PrivateRoute>
            <PrivateRoute path="/checkout">
              <Checkout />
            </PrivateRoute>
            <PrivateRoute path="/profile">
              <Profile />
            </PrivateRoute>
            <PrivateRoute path="/success">
              <Success />
            </PrivateRoute>
          </Switch>
          <Route />
        </Router>
      </CartContext.Provider>
    </div>
  );
}

export default App;
